import { render, staticRenderFns } from "./Gamifications.vue?vue&type=template&id=6db0b705&"
import script from "./Gamifications.vue?vue&type=script&lang=js&"
export * from "./Gamifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports